import { render, staticRenderFns } from "./logDashActivity.vue?vue&type=template&id=530fe686&scoped=true"
import script from "./logDashActivity.vue?vue&type=script&lang=js"
export * from "./logDashActivity.vue?vue&type=script&lang=js"
import style0 from "./logDashActivity.vue?vue&type=style&index=0&id=530fe686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530fe686",
  null
  
)

export default component.exports